import { Injectable } from "@angular/core";
import { GenericService } from "./generic.service";
import { NotificationsService } from "angular2-notifications";
import { CommunityPatrolApi } from "../api/community-patrol.api";
import { ICommunityPatrol } from "../model/community-patrol.model";
import { apiCallWrapper, createUrl } from "../api/api.util";

@Injectable()
export class CommunityPatrolService extends GenericService<ICommunityPatrol> {
  constructor(
    public communityPatrolApi: CommunityPatrolApi,
    public notifications: NotificationsService
  ) {
    super(communityPatrolApi, notifications);
  }

  listingCommunityPatrol(query: {
    page: number;
    limit: number;
    search: string;
    filter: Record<string, unknown>
  }) {
    return apiCallWrapper(
      this.communityPatrolApi.listingCommunityPatrol(query),
      {
        notificationsService: this.notifications,
        action: `Fetching Community Patrol Records`
      }
    );
  }

  // Admin-only: DELETE with reason in body
  deleteWithReason(id: string | number, reason: string) {
    const url = createUrl(this.communityPatrolApi.path, id);
    return apiCallWrapper(
      this.communityPatrolApi.httpClient.request<{ success: boolean; deleted?: number }>(
        'DELETE',
        url,
        { body: { reason } }
      ),
      {
        notificationsService: this.notifications,
        action: `Deleting community patrol ${id}`
      }
    );
  }

  // Admin-only: Fetch audit entries for a record
  getAudits(id: string | number) {
    // Backend route shape: GET /community-patrol/:id/audit
    const url = `${createUrl(this.communityPatrolApi.path, id)}/audit`;
    return apiCallWrapper(
      this.communityPatrolApi.httpClient.get<any>(url),
      {
        notificationsService: this.notifications,
        action: `Fetching Community Patrol Audit ${id}`,
        defaultValue: { items: [] }
      }
    );
  }
} 